const recordDetail = () => import(/* webpackChunkName: "csp-app/views/record/detail" */'@csp-app/views/record/Detail.vue');

export default [
    {
        path: '/',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "csp-app/views/dashboard" */'@csp-app/views/Dashboard.vue'),
    },
    {
        path: '/analytics',
        name: 'analytics',
        component: () => import(/* webpackChunkName: "csp-app/views/analytic" */'@csp-app/views/Analytic.vue'),
    },
    {
        path: '/inbox',
        name: 'inbox',
        component: () => import(/* webpackChunkName: "csp-app/views/inbox" */'@csp-app/views/Inbox.vue'),
    },
    {
        path: '/firms/current',
        name: 'firms.current',
        component: () => import(/* webpackChunkName: "csp-app/views/firm-data" */'@csp-app/views/FirmData.vue'),
    },
    {
        path: '/records/create',
        name: 'record-create',
        redirect: {name: 'record-create-section', params: {section: 'base'}},
    },
    {
        path: '/records/create/:section',
        name: 'record-create-section',
        component: () => import(/* webpackChunkName: "csp-app/views/record/create" */'@csp-app/views/record/Create.vue'),
    },
    {
        path: '/records/:recordId/create-success',
        name: 'record-create-success',
        component: () => import(/* webpackChunkName: "csp-app/views/record/create-success" */'@csp-app/views/record/CreateSuccess.vue'),
    },
    {
        path: '/records/list',
        name: 'record-list',
        component: () => import(/* webpackChunkName: "csp-app/views/record/list" */'@csp-app/views/record/List.vue'),
    },
    {path: '/record/:recordId', name: 'record-detail', component: recordDetail},
    {path: '/record/:recordId/:section', name: 'record-detail-section', component: recordDetail},
    {
        path: '/support',
        name: 'support',
        component: () => import(/* webpackChunkName: "csp-app/views/support" */'@csp-app/views/Support.vue'),
    },
    {
        path: '/users/current',
        name: 'users.current',
        component: () => import(/* webpackChunkName: "csp-app/views/user-data" */'@csp-app/views/UserData.vue'),
    },
];
